import type {
	CognitoUser,
	CognitoUserSession,
} from "amazon-cognito-identity-js";

export const RefreshSessionResolver = async (
	cognitoUser: CognitoUser | null,
): Promise<CognitoUserSession | null> => {
	if (!cognitoUser) return null;
	return new Promise((resolve) => {
		cognitoUser.getSession(
			(error: Error | null, session: CognitoUserSession | null) => {
				if (error || !session?.isValid()) return resolve(null);
				cognitoUser.refreshSession(
					session.getRefreshToken(),
					(error, newSession) => {
						if (error) {
							// Check if refresh token is expired and clear the user
							if (
								(error as any).code === "RefreshTokenRevoked" ||
								(error as any).message?.includes("Refresh Token has expired") ||
								(error as any).message?.includes("Invalid Refresh Token")
							) {
								cognitoUser.signOut();
							}
						}
						resolve(error || !newSession?.isValid() ? null : newSession);
					},
				);
			},
		);
	});
};
